<app-toast-message [justAfterLogin]="false">
</app-toast-message>

<main class="container-fluid p-0 h-100" aria-labelledby="registertitle">
  <app-preloader *ngIf="loginLoader" class="w-100 h-100 position-fixed preloader-backdrop"
    [loaderText]="'Processing...'">
  </app-preloader>

  <section class="row justify-content-center d-flex align-items-center" [ngClass]="{'h-100': (formPanel && getheight()) || success || isAlradyregister}">
    <div class="col-7 col-md-7 col-lg-5 col-xl-4 login-container">
      <div class="w-100 d-flex justify-content-between align-items-center login--heading login--heading__register">
        <div class="col-auto p-0">
          <h1 id="registertitle">
            <ng-container *ngIf="isRegister">Register</ng-container>
            <ng-container *ngIf="success">Registration Complete!</ng-container>
            <ng-container *ngIf="isAlradyregister">Registration Already Done!</ng-container>
          </h1>
        </div>

        <div class="col d-flex justify-content-end p-0 logo">
          <img src="https://frostdesignsystem.learningmate.co/assets/images/logo/frost-align.svg" class="img-fluid" alt="Frost Align Logo">
        </div>
      </div>

      <ng-container #formPanel *ngIf="isRegister">
        <p class="mt-3">Fields marked with an asterisk (<span class="mandatory">*</span>) are required.</p>
        <div class="row p-0">
          <div class="form-group col-12 mt-0">
            <label for="first_name" class="font-bold" id="first_nameLabel">First Name
              <span class="mandatory">*</span>
            </label>
            <input type="text" class="form-control font-bold" name="first_name" id="first_name"
              [formControl]="form.controls['username']" aria-required="true" [(ngModel)]="username"
              (keyup)="checkValidation();">
            <div class="error--txt" role="alert"
              *ngIf="form.controls['username'].hasError('required') && form.controls['username'].touched">
              <p class="font-bold m-0 d-flex align-items-center mt-1">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                First Name Required
             </p>
            </div>
          </div>
  
          <div class="form-group col-12 mt-0">
            <label for="last_name" class="font-bold" id="last_nameLabel">Last Name
              <span class="mandatory">*</span>
            </label>
            <input type="text" class="form-control font-bold" name="last_name" id="last_name"
              [formControl]="form.controls['username_last']" aria-required="true" [(ngModel)]="username_last"
              (keyup)="checkValidation();">
            <div class="error--txt" role="alert"
              *ngIf="form.controls['username_last'].hasError('required') && form.controls['username_last'].touched">
              <p class="font-bold m-0 d-flex align-items-center mt-1">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Last Name Required
             </p>
            </div>
          </div>
  
          <div class="form-group col-12 my-0">
            <label for="emailInputId" class="font-bold" id="emailInputIdLabel">Work Email
              <span class="mandatory">*</span>
            </label>
            <input #emailInput type="text" class="form-control font-bold" name="emailInputId" id="emailInputId"
              [formControl]="form.controls['email']" aria-required="true" [(ngModel)]="email"
              [attr.disabled]="disableEmail? 'true' : null">
            <div class="error--txt" role="alert">
              <p class="font-bold m-0 d-flex align-items-center mt-1" *ngIf="form.controls['email'].hasError('required') && form.controls['email'].touched">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Email is Required
             </p>
             <p class="font-bold m-0 d-flex align-items-center mt-1" *ngIf="form.controls['email'].touched && form.controls['email'].errors?.email">
              <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
              Please enter a valid Email.
           </p>
            </div>
          </div>
  
          <div class="form-group col-12 my-0" *ngIf="!isSSOUser">
            <label for="password" class="font-bold" id="passwordLabel">Password
              <span class="mandatory">*</span>
            </label>
            <input type="password" [(ngModel)]="passwordEnt" class="form-control font-bold" name="password" id="password"
              [formControl]="form.controls['password']" aria-required="true" (click)="click()"
              (keydown.space)="$event.preventDefault();" (keyup)="repasswordEntered($event.target.value);">
            <div class="error--txt">
              <p class="font-bold m-0 d-flex align-items-center mt-1" role="alert"
                *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Password is Required
              </p>
              <p class="font-bold m-0 d-flex align-items-center mt-1" role="alert"
                *ngIf="form.controls['password'].touched && form.controls['password'].hasError('minlength')">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Password must be minimum of 8 characters
              </p>
              <p class="font-bold m-0 d-flex align-items-center mt-1" role="alert"
                *ngIf="form.controls['password'].touched && form.controls['password'].hasError('maxlength')">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Password must be minimum of 12 characters
              </p>
              <p class="font-bold m-0 d-flex align-items-center mt-1" role="alert"
                *ngIf="form.controls['password'].touched && form.controls['password'].hasError('pattern')">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Password must contain a mixture of uppercase and lowercase letters, numbers and symbols
              </p>
            </div>
          </div>
  
          <div class="form-group col-12 my-0" *ngIf="!isSSOUser">
            <label for="confirmPassword" class="font-bold" id="confirmPasswordLabel">Confirm Password
              <span class="mandatory">*</span>
            </label>
            <input type="password" [(ngModel)]="repasswordEnt" (keyup)="repasswordEntered($event.target.value)"
              class="form-control font-bold" aria-required="true" name="confirmPassword" id="confirmPassword"
              [formControl]="form.controls['cpassword']" (click)="click()" (keydown.space)="$event.preventDefault();">
            <div class="error--txt">
              <div>
                <p class="font-bold m-0 d-flex align-items-center mt-1" role="alert" *ngIf="form.controls['cpassword'].hasError('required') && form.controls['cpassword'].touched">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                You must include confirm password
              </p>
              <p class="font-bold m-0 d-flex align-items-center mt-1" role="alert" *ngIf="form.controls['cpassword'].touched && !match">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Passwords do not match
              </p>
              </div>
            </div>
          </div>
  
          <div class="form-group col-12 mt-0" *ngIf="tocken === undefined">
            <h2 class="font-bold title-sub" id="optionalInformation">Optional Information</h2>
            <div role="group" aria-labelledby="optionalInformation">
  
              <div class="d-flex justify-content-start">
                <p class="mb-0 font-bold" id="k12">Are you a K-12 teacher?
                  <span id="k12Instruction" *ngIf="checkRadio === '1'" class="sr-only">Tab to select Grade Level taught
                    for K-12 or select Subject Areas Taught</span>
                </p>
                <div class="pl-4">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input class="custom-control-input" id="teacherYes" name="customRadioInline" type="radio" value="1"
                      [(ngModel)]="checkRadio" (click)="radioOptionSelected($event.target.value, 'teacher',$event)"
                      (keyup.space)="radioOptionSelected($event.target.value, 'teacher',$event)" aria-labelledby="k12">
                    <label class="custom-control-label font-bold" for="teacherYes">Yes</label>
                  </div>
                </div>
              </div>
  
              <div class="pb-2" *ngIf="checkRadio === '1'">
                <div class="d-flex justify-content-start" role="group" aria-labelledby="levelsTaught">
                  <p class="font-bold mb-2" id="levelsTaught">Grade Levels Taught</p>
                  <div class="d-flex justify-content-start">
                    <div id="levelsTaughtSet" class="pl-4" *ngFor="let level of gradeLevelList">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="{{level.name}}" [checked]="level.checked"
                          aria-describedby="levelsTaught" value="{{level.value}}"
                          (click)="checkboxSelected(level, 'grade')">
                        <label class="custom-control-label font-bold" id="{{level.value.split(' ').join('')}}label"
                          for="{{level.name}}" attr.aria-label="{{level.value}}">{{level.name}}</label>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="d-flex justify-content-start flex-wrap" role="group"
                  aria-labelledby="subjectAreas worldLanguages">
                  <div class="col-12 p-0">
                    <p class="mb-0 font-bold" id="subjectAreas">Subject Areas Taught</p>
                  </div>
                  <div class="d-flex justify-content-start col-12 p-0">
                    <p class="font-bold mb-0" id="worldLanguages">World Languages:</p>
                    <div class="pl-4" *ngFor="let sub of subjectAreas">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" aria-describedby="worldLanguages" type="checkbox"
                          id="{{sub.value}}" [checked]="sub.checked" value="{{sub.value}}"
                          (click)="checkboxSelected(sub, 'subject')">
                        <label class="custom-control-label font-bold" id="{{sub.name.split(' ').join('')}}Label"
                          for="{{sub.value}}">{{sub.name}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="d-flex justify-content-start pt-2">
                <p class="mb-0 font-bold" id="K12Admin">Are you a K-12 administrator?</p>
                <div class="pl-4">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input class="custom-control-input" id="K12adminYes" name="customRadioInline" type="radio" value="2"
                      [(ngModel)]="checkRadio" (click)="radioOptionSelected($event.target.value, 'teacher', $event)"
                      aria-labelledby="K12Admin">
                    <label class="custom-control-label font-bold" id="K12adminYesLabel" for="K12adminYes">Yes</label>
                  </div>
                </div>
  
              </div>
  
              <div class="d-flex justify-content-start pt-2">
                <p class="mb-0 font-bold" id="higherEducation">Do you work in Higher Education?</p>
                <div class="pl-4">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input class="custom-control-input" id="workHEyes" aria-labelledby="higherEducation"
                      name="customRadioInline" type="radio" value="3" [(ngModel)]="checkRadio"
                      (click)="radioOptionSelected($event.target.value, 'teacher',$event)">
                    <label class="custom-control-label font-bold" id="workHEyesLabel" for="workHEyes">Yes</label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-start pt-2">
                <p class="mb-0 font-bold" id="businessIndustry">Do you work in Business/Industry?</p>
                <div class="pl-4">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input class="custom-control-input" id="BIyes" aria-labelledby="businessIndustry"
                      name="customRadioInline" type="radio" value="4" [(ngModel)]="checkRadio"
                      (click)="radioOptionSelected($event.target.value, 'teacher',$event)">
                    <label class="custom-control-label font-bold" id="BIyesLabel" for="BIyes">Yes</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-2" role="group" aria-labelledby="lang">
              <p class="mb-2 font-bold" id="lang">Select all languages taught in your district or institution</p>
              <div class="row pt-1">
                <div class="col-sm-4" *ngFor="let lang of languagesList; let langIndex = index">
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" id="{{langIndex}}" [checked]="lang.checked" type="checkbox"
                      value="{{lang.value}}" (click)="checkboxSelected(lang, 'language')">
                    <label class="custom-control-label font-bold" id="{{langIndex}}+'Label'"
                      for="{{langIndex}}">{{lang.label}}</label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" id="other-lang" type="checkbox"
                      (change)="toggleEditable($event.target)">
                    <label class="custom-control-label font-bold" id="other-langLabel" for="other-lang">Other (enter
                      languages here)</label>
                  </div>
                  <ng-container *ngIf="showTextBox">
                    <label for="otherlang" class="custom-control" class="font-bold">Other Languages</label>
                    <input id="otherlang" class="form-control font-bold mt-2" [(ngModel)]="otherLangs"
                      aria-required="true" name="other-lang" type="text" aria-labelledby="otherLangSpecify">
                    <p class="m-0" class="sr-only" id="otherLangSpecify">please specify other language(s) taught.</p>
                  </ng-container>
                </div>
              </div>
            </div>
  
          </div>
          <div class="col-12 my-3" *ngIf="!skipCaptchaValidation">
            <re-captcha (resolved)="resolved($event)" siteKey="{{siteKey}}"></re-captcha>
          </div>
        </div>
        <div class="row align-items-center login--btn-set">
          <div class="col">
            <button type="button" class="btn btn-primary btn__login" id="onRegisterBtn" (click)="onRegister()"
              [disabled]="!form.valid || !match || (!skipCaptchaValidation && !captchaValidate) || !valid ">Register</button>
            <!-- dont remove this br. this is a hack for the accessibility -->
            <br>
          </div>
          <div class="col text-right">
            <button class="btn text-underline btn-link-text font-bold" id="goToLoginBtn" (click)="goToLogin()">Click
              to go back to Login!
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="success">
        <div class="col-12 p-0 mt-5">
          <p role="alert">You have successfully created your account!</p>
            <p role="alert">To begin using Frost Align you will need to activate your account via the email we have just
            sent to
            your address.
          </p>
          <button class="btn btn-primary btn__login" id="okBtn" (click)="goToLogin()">OK</button>
        </div>
      </ng-container>

      <ng-container *ngIf="isAlradyregister">
        <div class="col-12 p-0 mt-5">
          <p class="font-bold" role="alert">
            You are already registered to "Frost Align". You can login using the previously set User ID and Password.
          </p>
          <button type="button" class="btn btn-primary btn__login" (click)="goToLogin()">Done</button>
        </div>
      </ng-container>
    </div>
  </section>
</main>